import React from 'react';
import { FetchAPI, Mutex } from './auth-service';


class CMCsDataService {
    constructor () {
        if (!CMCsDataService.instance) {
            CMCsDataService.instance = this;
            this.namesMux = new Mutex();
        }

        this.list = () => {
            return FetchAPI({
                url: `mc2/cmc/`,
                method: 'GET',
            }).then(res => {
                if(!res) return [];
                return res;
            });
        };

        this.getNames = () => {
            return FetchAPI({
                url: `mc2/cmc/`,
                method: 'GET',
            }).then(r => {
                return (r || []).reduce((a, c) => {
                    a[c.uuid] = c.name;
                    return a;
                }, {})
            });
        };

        this.register= (name, data) => {
            return FetchAPI({
                url: `mc2/cmc/${name}/`,
                method: 'POST',
                body: data,
            });
        };

        this.get = (uuid) => {
            return FetchAPI({
                url: `mc2/cmc/${uuid}/`,
                method: 'GET',
            });
        };

        this.getStandby = () => {
            return FetchAPI({
                url: 'mc2/system/-standby/',
                method: 'GET',
            });
        };

        this.delete = (uuid) => {
            return FetchAPI({
                url: `mc2/cmc/${uuid}/`,
                method: 'DELETE',
            });
        };

        this.getLogs = (uuid) => {
            return FetchAPI({
                url: `mc2/cmc/${uuid}/health/logdump/`,
                method: 'GET',
            });
        };

        this.rename = (uuid, name) => {
            return FetchAPI({
                url: `mc2/cmc/${uuid}/${name}/`,
                method: 'PUT',
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_cmcs') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_cmcs', JSON.stringify(searches));
        };

        return CMCsDataService.instance;
    }

}

const CMCsService = new CMCsDataService();

// MC2 needs a cmc context for tags, assets (ip tool) etc..
const CmcContext = React.createContext({
    cmc: undefined,
    setCmc: cmc => {},
});

export {
    CMCsService as default,
    CmcContext,
};
